import { ProblemAlert } from '@/components/error-surface'
import type { ApiError } from '@/lib/problem-details'

import { savingsErrorGuidance } from './savings-error-messages'

/**
 * The shared problem alert, with the savings-specific next step under it where there is one.
 *
 * Two sentences rather than one merged into the other: the alert says what the server said, and
 * this says what to do about it. Conflating them would make the second look like a server message,
 * which it is not.
 */
export function SavingsProblemAlert({ error, className }: { error: ApiError; className?: string }) {
  const guidance = savingsErrorGuidance(error)

  return (
    <div className={className}>
      <ProblemAlert error={error} />
      {guidance ? <p className="mt-1.5 text-xs text-body">{guidance}</p> : null}
    </div>
  )
}
